import { Tooltip } from "antd"
import cls from "classname"

import Icon from "../../Icon"

import "./InfoTooltip.less"

const InfoTooltip = ({ title, className, ...props }) => {
  return (
    <Tooltip title={title} className={cls("info-tooltip", className)} {...props}>
      <div className="info-tooltip-icon-wrapper">
        <Icon className="info-tooltip-btn" type="circle_info_strong" style={{ fontSize: "16px" }} />
      </div>
    </Tooltip>
  )
}

export default InfoTooltip
